export function underSample(arr: number[], length: number) {
    if (arr.length <= length) return arr

    const step = Math.ceil(arr.length / length)

    // 21/07/23 Simon Willcock: Fixed a bug where the last element could be missing and the chart didn't display correctly
    // Modified the code below now (i === arr.length - 1) checks if the current index is the last one in the array. 
    // If it is, the corresponding element is included in the resulting array. 
    // This ensures that the last element of the original array is always included in the undersampled array, 
    // even if its index is not a multiple of the step size.
    return arr.filter(function (val, i, ar) {
        return (i % step == 0) || (i === arr.length - 1);
    });
}